var Backbone, FAQAppRouter,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

FAQAppRouter = (function(superClass) {
  extend(FAQAppRouter, superClass);

  function FAQAppRouter() {
    return FAQAppRouter.__super__.constructor.apply(this, arguments);
  }

  FAQAppRouter.prototype.routes = {
    '': 'renderFaq',
    ':id': 'renderFaq'
  };

  FAQAppRouter.prototype.renderFaq = function(id) {
    if (id == null) {
      id = "home";
    }
    return Groupon.FAQ.ViewManager.render(id);
  };

  return FAQAppRouter;

})(Backbone.Router);

module.exports = FAQAppRouter;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUva3VtYXJyYS9uYXBpc3RyYW5vL2J1aWxkLzE1MDQ3NzgxNDM1MjYtNzYxNzcvcHJvZHVjdGlvbi0yMDE3LjA5LjA3XzA5LjU0L3N1cHBvcnRfYXBwL21vZHVsZXMvZmFxL2Zyb250ZW5kL0FwcHJvdXRlci5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9rdW1hcnJhL25hcGlzdHJhbm8vYnVpbGQvMTUwNDc3ODE0MzUyNi03NjE3Ny9wcm9kdWN0aW9uLTIwMTcuMDkuMDdfMDkuNTQvc3VwcG9ydF9hcHAvbW9kdWxlcy9mYXEvZnJvbnRlbmQvQXBwcm91dGVyLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBLHNCQUFBO0VBQUE7OztBQUFBLFFBQUEsR0FBVyxPQUFBLENBQVEsVUFBUjs7QUFFTDs7Ozs7Ozt5QkFDSixNQUFBLEdBQ0U7SUFBQSxFQUFBLEVBQUssV0FBTDtJQUNBLEtBQUEsRUFBUSxXQURSOzs7eUJBR0YsU0FBQSxHQUFZLFNBQUMsRUFBRDs7TUFBQyxLQUFLOztXQUNoQixPQUFPLENBQUMsR0FBRyxDQUFDLFdBQVcsQ0FBQyxNQUF4QixDQUErQixFQUEvQjtFQURVOzs7O0dBTGEsUUFBUSxDQUFDOztBQVFwQyxNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
